import MeetingChatLayout from './ChatLayout';

export default MeetingChatLayout;

